import { render } from "./DashboardOfferDescription.vue?vue&type=template&id=f54dc7e8"
import script from "./DashboardOfferDescription.vue?vue&type=script&lang=ts"
export * from "./DashboardOfferDescription.vue?vue&type=script&lang=ts"
script.render = render

export default script